import { render, staticRenderFns } from "./MyTagReward.vue?vue&type=template&id=71bad300&scoped=true"
import script from "./MyTagReward.vue?vue&type=script&lang=js"
export * from "./MyTagReward.vue?vue&type=script&lang=js"
import style0 from "./MyTagReward.vue?vue&type=style&index=0&id=71bad300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bad300",
  null
  
)

export default component.exports